import * as Yup from "yup";

const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/gif", "image/png"];
const FILE_SIZE = 160 * 1024;

export const registerValidationSchema2 = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  speciality: Yup.string().required("Specialties is required"),
  city: Yup.string().required("City is required"),
  gender: Yup.string().required("Gender is required"),
  email: Yup.string(),
  years_of_experience: Yup.number().required("Experience is required"),
  profile_picture: Yup.mixed()
    .test(
      "fileSize",
      "File too large",
      (value) => value === null || (value && value.size <= FILE_SIZE)
    )
    .test(
      "fileFormat",
      "Unsupported file type",
      (value) =>
        value === null || (value && SUPPORTED_FORMATS.includes(value.type))
    ),
});

export const registerValidationSchema1 = Yup.object().shape({
  pmdc: Yup.string(),

  phone_number: Yup.string(),
});

export const editDoctorValidation = Yup.object().shape({
  pmdc: Yup.string(),
  // .required("PMDC Number is required")
  // .matches(/[0-9]-([A-Z])/g, "PMDC is not valid"),
  phone_number: Yup.string(),
  // .required("Phone Number is required")
  // .test("test-name", "Enter Valid Phone", function (value: any) {
  //   const phoneRegExp = /^((0)?)(3)([0-9]{9})$/gm;
  //   let isValidPhone = phoneRegExp.test(value);
  //   if (!isValidPhone) {
  //     return false;
  //   }
  //   return true;
  // }),
  name: Yup.string().required("Name is required"),
  speciality: Yup.string().required("Specialties is required"),
  city: Yup.string().required("City is required"),
  gender: Yup.string().required("Gender is required"),
  email: Yup.mixed(),
  years_of_experience: Yup.number().required("Experience is required"),
  profile_picture: Yup.mixed(),
});

export const aboutValidationSchema = Yup.object().shape({
  about_text: Yup.string()
    .required("Please write about yourself")
    .min(10, "to short"),
});

export const addManufacturerValidationSchema = Yup.object().shape({
  manufacturer_name: Yup.string().required("Required *"),
});
export const addcategoryValidationSchema = Yup.object().shape({
  category_name: Yup.string().required("Required *"),
});
export const addSupplierValidationSchema = Yup.object().shape({
  //supplier_name: Yup.string().required("Required *"),
  supplier_name: Yup.string()
    .required("Required *")
    .matches(/^[A-Za-z\s]+$/, "Enter characters only"),
  contact_person: Yup.string()
    .required("Required *")
    .matches(/^[A-Za-z\s]+$/, "Enter characters only"),
  phone_number: Yup.string()
    .required("Required *")
    .matches(/^\d{11}$/, "Enter Valid Phone number")
    .max(11, "Enter Valid Phone number"),
  // email: Yup.string().required("Required *"),
  email: Yup.string()
    .nullable() // Allows null or empty values
    .matches(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.com$/, {
      message: "Enter a valid email",
      excludeEmptyString: true,
    }),
});
export const editSupplierValidationSchema = Yup.object().shape({
  supplier_name: Yup.string().required("Required *"),
  contact_person: Yup.string().required("Required *"),
  phone_number: Yup.string().required("Required *"),
  //email: Yup.string().required("Required *"),
});
export const editCustomerValidationSchema = Yup.object().shape({
  name: Yup.string().required("Required *"),
  phone_number:  Yup.string()
  .required("Required *")
  .matches(/^\d{11}$/, "Enter Valid Phone number")
  .max(11, "Enter Valid Phone number"),
// email: Yup.string()
// .nullable() 
// .matches(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.com$/, {
//   message: "Enter a valid email",
//   excludeEmptyString: true,
// }),
});
export const addUserManagementValidationSchema = Yup.object().shape({
  name: Yup.string().required("Required *"),
  designation: Yup.string().required("Required *"),
  phone_number: Yup.string().required("Required *"),
  email: Yup.string().required("Required *"),
});
export const addMedicineFormulaValidationSchema = Yup.object().shape({
  drug_formula_name: Yup.string().required("Required *"),
});
export const addBatchValidationSchema = Yup.object().shape({
  // medicine_id: Yup.string()
  // .required("Required *"),

  batch_no: Yup.string()
    .required("Required *")
    .test("is-valid", "Please enter a valid number or characters", (value) => {
      if (!value) return true;
      const isPositiveNumber = /^\d+$/.test(value) && parseInt(value, 10) > 0;
      const containsCharacters = /[a-zA-Z]/.test(value);
      const containsNegativeCharacters = /[-]/.test(value);
      return (
        (isPositiveNumber || containsCharacters) && !containsNegativeCharacters
      );
    }),

  quantity: Yup.string()
    .required("Required *")
    .test("is-non-negative", "Please enter a valid number", (value) => {
      if (!value) return true;
      return /^\d+$/.test(value);
    }),

  sell_price: Yup.string()
    .required("Required *")
    .test("is-non-negative", "Please enter a valid number", (value) => {
      if (!value) return true;
      return /^\d+$/.test(value);
    }),

  cost_price: Yup.string()
    .required("Required *")
    .test("is-non-negative", "Please enter a valid number", (value) => {
      if (!value) return true;
      return /^\d+$/.test(value);
    })
    .test(
      "is-less-than-sell-price",
      "Cost price must be less than sell price",
      function (value: any) {
        const sellPrice = this.parent.sell_price;
        return !sellPrice || parseInt(value) <= parseInt(sellPrice);
      }
    ),

  // production_date: Yup.string().required("Production date is required"),
  // expiry_date: Yup.string().required("Expiry date is required"),
});
export const addProfileValidationSchema = Yup.object().shape({
  name: Yup.string().required("Pharmacy name is required"),
  // city: Yup.string().required("City is required"),
  address: Yup.string().required("Address is required"),
  contact_number: Yup.string(),
  // .test(
  // phone: Yup.string().test(
  //   "test-name",
  //   "Enter Valid Phone",
  //   function (value: any) {
  //     const phoneRegExp = /^((0)?)(3)([0-9]{9})$/gm;
  //     let isValidPhone = phoneRegExp.test(value);
  //     if (!isValidPhone) {
  //       return false;
  //     }
  //     return true;
  //   }
  // ),
  logo: Yup.mixed()
    .test(
      "fileSize",
      "File too large",
      (value) => value === null || (value && value.size <= FILE_SIZE)
    )
    .test(
      "fileFormat",
      "Unsupported file type",
      (value) =>
        value === null || (value && SUPPORTED_FORMATS.includes(value.type))
    ),
});
export const addMedicineValidationSchema = Yup.object().shape({
  medicine_name: Yup.string().required("Required *"),
  //dose: Yup.string().required("Dose is required"),
  //generic_name: Yup.string().required("Required *"),
  //manufacturer_id:Yup.string().required("Manufaturer name is required"),
});

export const regMedicalValidationSchema = Yup.object().shape({
  medicine_name: Yup.string().required("Required *"),
  //dose: Yup.string().required("Dose is required"),
  //generic_name: Yup.string().required("Required *"),
  //manufacturer_id:Yup.string().required("Manufaturer name is required"),
});

export const addOwnerClinicValidationSchema = Yup.object().shape({
  email: Yup.string(),
  clinic_name: Yup.string().required("Clinic name is required"),
  city: Yup.string().required("City is required"),
  address: Yup.string().required("Address is required"),
  clinic_phone_number: Yup.string(),

  logo_url: Yup.mixed(),
});
export const addClinicOwnerValidationSchema = Yup.object().shape({
  name: Yup.string().required("Clinic name is required"),
  phone_number: Yup.string(),
});
export const profileValidationSchema = Yup.object().shape({
  name: Yup.string().required("This field is required"),
  phone_number: Yup.string(),

  dob: Yup.string().required("Dob is required"),
  gender: Yup.string().required("Gender is required"),
  profile_picture: Yup.mixed(),
});

export const loginValidationSchema = Yup.object().shape({
  user_id: Yup.string(),
});
export const cresitAmountValidationSchema = Yup.object().shape({
  credit_amount: Yup.string(),
  category_id: Yup.string(),
  category: Yup.string(),
  transaction_type: Yup.string(),
});
export const registerStaffValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  designation: Yup.string().required("Designation is required"),
  email: Yup.string(),
  phone_number: Yup.string(),
});

export const addBankAccountValidationSchema = Yup.object().shape({
  bank_name: Yup.string().required("Please select bank"),
  account_title: Yup.string().required("Please select bank"),
  account_number: Yup.number()
    .typeError("IBAN should be numbers only")
    .required("Please enter bank account number"),
});

export const AdminLoginValidationSchema = Yup.object().shape({
  email: Yup.string(),

  password: Yup.string().required("Enter Password"),
});
export const addSpecilitiesValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  description: Yup.string().required("Description is required"),
});
export const addSpecilitiesTagValidationSchema = Yup.object().shape({
  tag: Yup.string().required("Tags field is required"),
});
export const DiseaseTagValidationSchema = Yup.object().shape({
  disease: Yup.string().required("Disease field is required"),
});
export const TreatmentTagValidationSchema = Yup.object().shape({
  treatment: Yup.string().required("Treatment field is required"),
});
export const addUniversityValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  country: Yup.string().required("Country is required"),
  region: Yup.string().required("Region is required"),
  verified: Yup.string().required("Verified is required"),
});
export const addDiscountValidationSchema = Yup.object().shape({
  new_discount_percentage_value: Yup.string().required(
    "new_service_fee_percentage_value is required"
  ),
  new_service_fee_percentage_value: Yup.string().required(
    "new_service_fee_percentage_value is required"
  ),
});
export const addReleaseNoteValidationSchema = Yup.object().shape({
  release_notes: Yup.string().required("required"),
  is_locking_version: Yup.string().required("required"),
  release_version: Yup.string().required("required"),
});
export const editReleaseNoteValidationSchema = Yup.object().shape({
  release_notes: Yup.string().required("required"),
  is_locking_version: Yup.string().required("required"),
  release_version: Yup.string().required("required"),
  release_detail_id: Yup.string(),
});
export const subscriptionValidationSchema = Yup.object().shape({
  doctor: Yup.string().required("doctor is required"),
  staff: Yup.string().required("staff is required"),
  attachment: Yup.string().required("attachment is required"),
  price: Yup.string().required("price is required"),
});
export const addSubscriptionValidationSchema = Yup.object().shape({
  Subscription: Yup.string().required("Please select subscription Package"),
});
export const addBankValidationSchema = Yup.object().shape({
  name: Yup.string().required("name is required"),
});
export const addLabTestValidationSchema = Yup.object().shape({
  lab_test_name: Yup.string().required("Name is required"),
  lab_test_price: Yup.string().required("Price is required"),
});
export const addProcedureValidationSchema = Yup.object().shape({
  procedure_name: Yup.string().required("Name is required"),
  procedure_price: Yup.string().required("Price is required"),
});

export const addStaffValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  role_id: Yup.string().required("Role is required"),
  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Email is required")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Email must be a valid format"
    ),
  contact_number: Yup.string()
    .required("Phone number is required")
    .matches(
      /^[0-9]{11}$/,
      "Phone number must be 11 digits long and contain only numbers"
    ),
});
